/* Helper to hide the Tawk.to chat bubble while a full-screen overlay
   is open (mobile menu, language sheet, etc.). Tawk renders its
   launcher iframe at body level with an internal z-index of ~1e6, so
   no amount of CSS stacking on our overlays will cover it — we have
   to either call Tawk's own API or apply a CSS rule scoped to a body
   data-attribute. We do both: API call if Tawk has booted, CSS attr
   either way (so the bubble is hidden even before Tawk finishes
   loading). */

const OVERLAY_ATTR = "data-nav-overlay";

let stackDepth = 0; // number of overlays currently asking for hidden

function applyState() {
  if (typeof document === "undefined") return;
  if (stackDepth > 0) {
    document.body.setAttribute(OVERLAY_ATTR, "1");
    try { window.Tawk_API?.hideWidget?.(); } catch (_e) { /* not ready */ }
  } else {
    document.body.removeAttribute(OVERLAY_ATTR);
    try { window.Tawk_API?.showWidget?.(); } catch (_e) { /* not ready */ }
  }
}

export function pushOverlay() {
  stackDepth += 1;
  applyState();
}

export function popOverlay() {
  stackDepth = Math.max(0, stackDepth - 1);
  applyState();
}
